module.exports = ".text-blue {\r\n  color: #006caa;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/course/labs/awsop/awsop-lab3/awsop-lab3.component.css
// module id = ./src/app/course/labs/awsop/awsop-lab3/awsop-lab3.component.css
// module chunks = main